import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    headerHeight: 0,
    modal: {
      title: ``,
      visible: false
    },
    videoModal: {
      visible: false
    }
  },
  getters: {
    headerHeight (state) {
      return state.headerHeight
    },
    modal (state) {
      return state.modal
    },
    videoVisible (state) {
      return state.videoModal.visible
    }
  },
  mutations: {
    setHeaderHeight (state, payload) {
      state.headerHeight = payload
    },
    showModal (state, payload) {
      state.modal.visible = true
      state.modal.title = payload.title
    },
    hideModal (state) {
      state.modal.visible = false
    },
    showVideoModal (state) {
      state.videoModal.visible = true
    },
    hideVideoModal (state) {
      state.videoModal.visible = false
    }
  },
  actions: {
    setHeaderHeight (context, payload) {
      context.commit(`setHeaderHeight`, payload)
    },
    showModal (context, payload) {
      context.commit(`showModal`, payload)
    },
    hideModal (context) {
      context.commit(`hideModal`)
    },
    showVideoModal (context) {
      context.commit(`showVideoModal`)
    },
    hideVideoModal (context) {
      context.commit(`hideVideoModal`)
    }
  }
})
